import { createSlice } from "@reduxjs/toolkit";
import {
	loginAPI,
	registerAPI,
	logoutAPI,
	validateToken,
} from "../../services/AuthService";
import { decodeToken } from "../../lib/network/TokenUtility";

interface AuthState {
	email: string;
	role: string;
	isAuthenticated: boolean;
	isReady: boolean;
	accessToken: string | null;
	error: string | undefined;
	loading: boolean;
}

const accessToken = localStorage.getItem("accessToken");
const decodedAccessToken = accessToken ? decodeToken(accessToken) : null;

const initialState: AuthState = {
	email: decodedAccessToken?.username || "",
	role: decodedAccessToken?.role || "",
	isAuthenticated: Boolean(accessToken && decodedAccessToken),
	accessToken: accessToken || null,
	isReady: Boolean(accessToken),
	error: undefined,
	loading: false,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(validateToken.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.isAuthenticated = payload?.status === 200 ? true : false;
				state.email = payload?.data.email;
				state.role = payload?.data.role;
				state.isReady = true;
				state.error = undefined;
			})
			.addCase(validateToken.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
				state.isReady = true;
				state.isAuthenticated = false;
				state.role = "";
				state.email = "";
			})
			.addCase(loginAPI.pending, (state) => {
				state.loading = true;
				state.error = undefined;
				})
			.addCase(loginAPI.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.email = payload?.email;
				state.accessToken = payload?.accessToken;
				state.role = payload?.role;
				state.isAuthenticated = true;
				state.isReady = true;
				state.error = undefined;
			})
			.addCase(loginAPI.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
				state.isReady = true;
				state.isAuthenticated = false;
				state.role = "";
				state.email = "";
			})
			.addCase(registerAPI.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.email = payload?.email || "";
				state.accessToken = payload?.accessToken;
				state.role = payload?.role || "";
				state.isReady = true;
				state.error = undefined;
			})
			.addCase(registerAPI.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
				state.isReady = false;
				state.isAuthenticated = false;
				state.role = "";
				state.email = "";
			})
			.addCase(logoutAPI.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.email = "";
				state.accessToken = "";
				state.role = "";
				state.isReady = false;
				state.error = undefined;
				state.isAuthenticated = false;
			})
			.addCase(logoutAPI.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
				state.isReady = false;
				state.isAuthenticated = false;
				state.role = "";
				state.email = "";
			});
	},
});

export default authSlice.reducer;
